import ajax from './index'

// 获取七牛云的上传token
export function qiniuToken(data) {
  return ajax.get('/v2/common/image_upload', data)
}
